import { render, staticRenderFns } from "./SingleDetail.vue?vue&type=template&id=fec8cefc&scoped=true&"
import script from "./SingleDetail.vue?vue&type=script&lang=js&"
export * from "./SingleDetail.vue?vue&type=script&lang=js&"
import style0 from "../../style.css?vue&type=style&index=0&id=fec8cefc&prod&scoped=true&lang=css&"
import style1 from "./SingleDetail.vue?vue&type=style&index=1&id=fec8cefc&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec8cefc",
  null
  
)

export default component.exports